<template>
  <div style="padding: 1.5rem; border-radius: 1rem; background-color: #fff">
    <h1 style="color: #000; margin-top: 0">
      Code: {{ this.$route.params.code }}
    </h1>
    <qrcode-vue :value="value" :size="size" level="M" />
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";

export default {
  data() {
    return {
      value: "https://profiling.star-horizon.com/" + this.$route.params.code,
      size: 400,
    };
  },
  components: {
    QrcodeVue,
  },
};
</script>
